import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LoadTransportersSuccessAction, transportersActionTypes} from '../actions/transporters';
import {Transporter} from '../models/transporter';

export interface TransportersState {
  array: Transporter[];
}

const initialState: TransportersState = {
  array: []
};

export function TransportersReducer(state: TransportersState = initialState, action: Action): TransportersState {
  switch (action.type) {
    case transportersActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case transportersActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: TransportersState, action: LoadTransportersSuccessAction): TransportersState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: TransportersState): TransportersState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const transportersSelectors = {
  array: (state: TransportersState) => _.get(state, 'array', [])
};
